import React, { useState, useEffect } from 'react'
import styles from './CAEJOutreachMode.module.css'
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../store/auth-context'
import { useContext } from 'react'
import { toast } from 'react-toastify';

const CAEJOutreachMode = (props) => {
    const { jobIdentifier } = props
    const authCtx = useContext(AuthContext)
    const [creditsSummary, setCreditsSummary] = useState({
        "recruiter_id": "999964N8406",
        "campaigns_today": "1",
        "messages_today": "5",
        "sent_today": "5",
        "campaigns_this_week": "1",
        "messages_this_week": "5",
        "sent_this_week": "5",
        "campaigns_this_month": "1",
        "messages_this_month": "5",
        "sent_this_month": "5",
        "total_credits_alloted": 2500,
        "total_credits_left": 2498.584
    })
    const [isSendingBulkSms, setIsSendingBulkSms] = useState(false)
    const [activeTemplate, setActiveTemplate] = useState('')
    const [targetNumbers, setTargetNumbers] = useState(0)
    const waSMSCost = 0.8968; // Cost per WhatsApp message in INR

    // let's fetch credits summary data from api
    const fetchCreditsSummary = async () => {
        const response = await fetch(BASE_URL_API + "/getOutreachCreditsSummary",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    executiveIdentifier: authCtx.userIdentifier
                })
            });
        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                setCreditsSummary(respo.response)
            } else {
                if (respo.message === "token Expired, please login again!") {
                    authCtx.logout()
                } else {
                    setCreditsSummary({})
                }
            }
            console.log(respo)
        }
    }

    useEffect(() => {
        fetchCreditsSummary()
        getOutreachTemplateActive()
    }, [jobIdentifier])
    console.log(authCtx.userIdentifier)

    const getOutreachTemplateActive = async () => {
        const response = await fetch(BASE_URL_API + "/getOutreachTemplateActive",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    executiveIdentifier: authCtx.userIdentifier,
                    jobIdentifier : jobIdentifier
                })
            });
        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                console.log(respo.response)
                setActiveTemplate(respo.response.templateIdentifier)
                setTargetNumbers(respo.response.targetNumbers)
            } else {
                if (respo.message === "token Expired, please login again!") {
                    authCtx.logout()
                } else {
                    console.log("No active template found")
                    setActiveTemplate('')
                    setTargetNumbers(0)
                }
            }
            console.log(respo)
        }   
    }

    const sendBulkOutReachMessage = async (messageType) => {
        if(activeTemplate === '') {
            toast("No active template found for this job, please contact your manager.")
            return
        }
        if(targetNumbers === 0) {
            toast("No target candidates found for this job, please contact your manager.")
            return
        }
        setIsSendingBulkSms(true)
        const response = await fetch("https://api.bmp.stylelink.in/api/messaging/send-campaign",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "campaignId": "random_01",
                    "messageType": messageType, // "sms" or "whatsapp"
                    "jobIds": [jobIdentifier],
                    // "templateId": "1707176810489092108",
                    // "templateId": "WA_MISSED_IMPORTANT_CALL_HI",
                    // "templateId": "WA_MISSED_IMPORTANT_CALL_EN",
                    // "templateId": "WA_IMPORTANT_ALERT_2_ENUS",
                    // "templateId": "WA_IMPORTANT_ALERT_4_HI",
                    "templateId": activeTemplate,
                    "recruiterId": authCtx.userIdentifier
                })
            }
        );

        if (!response.ok) {
            console.log("Something went wrong : Server error")
        } else {
            const respo = await response.json()
            if (respo?.success === true) {
                fetchCreditsSummary()
                toast(respo?.message)
            } else {
                toast(`Something went wrong : Server Error`)
            }
            console.log(respo)
        }
        setIsSendingBulkSms(false)
    }

    const isWithinSendingWindow = () => {
        const now = new Date();

        // Convert current time to IST
        const istTime = new Date(
            now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
        );

        const hours = istTime.getHours();
        const minutes = istTime.getMinutes();

        // Start: 10:00 AM
        const startMinutes = 10 * 60;

        // End: 8:00 PM
        const endMinutes = 20 * 60;

        const currentMinutes = hours * 60 + minutes;

        return currentMinutes >= startMinutes && currentMinutes <= endMinutes;
    };


    return (
        <div className={styles.outreachModeContainer}>
            <div className={styles.outreachModeHeader}>
                <div className={styles.outreachModeSubtitle}>
                    Now outreach to potential candidates effectively, with single click. Manage your communications and track responses all in one place.
                    This is powerful tool, it will send sms to the candidates on your behalf all at one shot. You can send messages to all 300 candidates in one go.
                    <p>Few instructions:</p>
                    <ul>
                        <li><b>DO NOT SEND MESSAGE BEFORE 10:05 AM AND AFTER 8:00 PM IN ANY SCENARIO, AS THE PROMOTIONAL SMS IS NOT ALLOWED DURING THIS TIME.</b></li>
                        <li>You should send messages to the candidates for each day once in a day.</li>
                        <li>If candidates overlap with previous outreach, you don't have to worry about sending messages as the system is smart enough to handle it. Hence you can send message without concern of duplication.</li>
                        <li>For best results, ensure you send messages in the beginning of the day or mid except after 5pm.</li>
                        <li>Make sure you have sufficient sms credits in your account to perform outreach.</li>
                        <li>Each message comes with a cost of <b>{waSMSCost} paisa</b>, in one go we are sending maximum {parseInt(targetNumbers)} messages, so every job comes with around <b>₹{(waSMSCost * parseInt(targetNumbers)).toFixed(2)}</b> of cost. Hence make the best and wiser use of it.</li>
                    </ul>
                </div>
            </div>

            <div className={styles.outreachModeContent}>
                <div className={styles.creditsCard}>
                    <div className={styles.creditRow}>
                        <span>Total Credits Used this month:</span>
                        <span className={styles.creditAmount}>₹{parseInt(creditsSummary.sent_this_month * waSMSCost) || 0}</span>
                    </div>
                    <div className={styles.creditRow}>
                        <span>Total Credits Used this week:</span>
                        <span className={styles.creditAmount}>₹{parseInt(creditsSummary.sent_this_week * waSMSCost) || 0}</span>
                    </div>
                    <div className={styles.creditRow}>
                        <span>Total Credits Used today:</span>
                        <span className={styles.creditAmount}>₹{parseInt(creditsSummary.sent_today * waSMSCost) || 0}</span>
                    </div>
                    <div className={styles.creditRowLast}>
                        <span>Total Credits Left:</span>
                        <span className={styles.creditAmount}>₹{creditsSummary?.total_credits_left}</span>
                    </div>
                </div>

                {/* let's put a logic to find if the time is within the sending window or not, it should be 10am ist to 8pm ist  */}

                {!isWithinSendingWindow() ?
                    <div className={styles.actionCard}>
                        <div className={styles.statusMessage}>
                            Bulk message sending will be available during non-blackout timings, i.e., 10:05 AM - 08:00 PM
                        </div>
                    </div>
                    :
                    <div className={styles.actionCard}>
                        {creditsSummary?.total_credits_left > 0 ? (
                            <div>
                                <div className={styles.statusMessage}>
                                    You have sufficient credits to perform outreach for this job.
                                </div>
                                <div className={styles.outreachModeAction}>
                                    {isSendingBulkSms === false ?
                                        <button disabled={isSendingBulkSms} onClick={() => sendBulkOutReachMessage('whatsapp')} >Send Outreach Messages</button>
                                        :
                                        <button disabled={isSendingBulkSms}  >Sending Messages ....</button>
                                    }
                                </div>
                            </div>
                        ) : (
                            <div className={styles.warningMessage}>
                                You do not have sufficient credits to perform outreach for this job. Please contact your manager.
                            </div>
                        )}
                    </div>
                }

            </div>
        </div>
    )
}

export default CAEJOutreachMode